import React from 'react'
import styles from "./NotFound.module.css"
import notFoundImg from "./../../../images/404.png"
import { Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const NotFound = () => {
  const navigateTo = useNavigate();

  return (
    <div className={styles.notFoundContainer}>
      <img src={notFoundImg} alt="404" className={styles.image} />
      <Button onClick={() => navigateTo("/")} sx={{ backgroundColor: "#207d46", color: "#FFFFFF", marginTop: "3rem", fontWeight: 600 }} >HOME</Button>
    </div>
  )
}

export default NotFound